import React from 'react';
import { FilledButton, SvgIcon } from '@make-software/tg-mini-app-ui';
import { useNavigate } from 'react-router-dom';

import { HOME_PATH } from '@/app/paths';
import Round1Icon from '@/shared/assets/icons/ic-round1.svg';
import Round2Icon from '@/shared/assets/icons/ic-round2.svg';

import { ActivityText, EmptyContainer } from './styled';

export const EmptyRound: React.FC<{ round?: number }> = ({ round = 1 }) => {
  const navigate = useNavigate();
  const onBackHomePress = () => navigate(HOME_PATH);
  const isRound1 = round === 1;

  const text = isRound1
    ? "Looks like you haven't supported any project yet. Go to the home screen and make your pick!"
    : 'Your Round 2 pick could change everything—go back home and decide who wins!';

  return (
    <EmptyContainer gap={10}>
      <SvgIcon src={isRound1 ? Round1Icon : Round2Icon} size={250} />
      <ActivityText weight={3} size="lg" style={{ width: '100%', textAlign: 'left' }}>
        {text}
      </ActivityText>
      <FilledButton title="Back to Home" onClick={onBackHomePress} fontFamily="Inter" />
    </EmptyContainer>
  );
};
